import React from "react";
import "./AppSidebar.css";
import { Link, NavLink } from "react-router-dom";
import navigation from "../../_nav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

const AppSidebar = ({ closeSidebar = () => {}, showClose = false }) => {
  const renderItem = (item) => {
    const content = (
      <>
        <span className="nav_icon">
          <FontAwesomeIcon icon={item.icon} />
        </span>
        <span className="nav_text">{item.name}</span>
      </>
    );

    // External link (e.g. shop). Disabled until a URL is configured.
    if (item.href !== undefined) {
      return item.href ? (
        <a
          key={item.name}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          className="nav_item"
          onClick={closeSidebar}
        >
          {content}
          <FontAwesomeIcon
            icon={faArrowUpRightFromSquare}
            className="nav_external"
          />
        </a>
      ) : (
        <span
          key={item.name}
          className="nav_item is_disabled"
          aria-disabled="true"
        >
          {content}
          <span className="nav_soon">Soon</span>
        </span>
      );
    }

    return (
      <NavLink
        key={item.name}
        to={item.to}
        className={({ isActive }) => `nav_item ${isActive ? "active" : ""}`}
        onClick={closeSidebar}
      >
        {content}
      </NavLink>
    );
  };

  return (
    <aside className="sidebar_main">
      <div className="logo_div">
        <Link to="/dashboard" className="brand_name" onClick={closeSidebar}>
          <span className="brand_logo">
            <img src="/assets/images/Ayurlife(1).webp" alt="AyurLife" />
          </span>
          <span className="brand_text">
            <strong>AyurLife</strong>
            <small>Member Panel</small>
          </span>
        </Link>

        {showClose && (
          <button
            type="button"
            className="sidebar_close"
            onClick={closeSidebar}
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
      </div>

      <nav className="sidebar_list" aria-label="Main navigation">
        {navigation.map((group, groupIndex) => (
          <div className="nav_group" key={group.title || groupIndex}>
            {group.title && <p className="section_title">{group.title}</p>}
            {group.items.map(renderItem)}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default AppSidebar;
